{
    "up.common.cancel": "취소",
    "up.common.confirm": "확인",
    "up.common.start": "시작",
    "up.common.end": "종료",
    "up.common.stop": "정지",
    "up.common.copy": "복사",
    "up.common.none": "없음",
    "up.common.tip": "팁",
    "up.common.success": "성공",
    "up.common.fail": "실패",
    "up.common.close": "닫기",
    "up.common.preview": "미리보기",
    "up.common.re-select": "재선택",
    "up.common.rotate": "회전",
    "up.common.pleaseChoose": "선택해주세요",
    "up.common.loading": "로딩중",
    "up.common.loading2": "로딩중",
    "up.common.inOperation": "작업중",
    "up.common.settings": "설정",
    "up.common.retry": "재시도",
    "up.common.search": "검색",
    "up.common.more": "더보기",
    "up.common.video": "비디오",
    "up.common.file": "파일",
    "up.week.one": "월",
    "up.week.two": "화",
    "up.week.three": "수",
    "up.week.four": "목",
    "up.week.five": "금",
    "up.week.six": "토",
    "up.week.seven": "일",
    "up.barcode.error": "바코드 생성 실패",
    "up.calendar.chooseDates": "날짜 선택",
    "up.calendar.disabled": "해당 날짜는 사용할 수 없습니다",
    "up.calendar.daysExceed": "선택한 날짜 수가 {days}일을 초과할 수 없습니다",
    "up.cityLocate.locateCity": "도시 위치 찾기",
    "up.cityLocate.fail": "위치 찾기 실패, 다시 시도하려면 클릭하세요.",
    "up.cityLocate.locating": "위치 찾는 중",
    "up.code.send": "인증코드 받기",
    "up.code.resendAfter": "X초 후 재전송",
    "up.code.resend": "재전송",
    "up.cropper.emptyWidhtOrHeight": "자르기 영역의 너비 또는 높이가 설정되지 않았습니다",
    "up.empty.car": "장바구니가 비어 있습니다",
    "up.empty.page": "페이지가 존재하지 않습니다",
    "up.empty.search": "검색 결과가 없습니다",
    "up.empty.address": "배송 주소가 없습니다",
    "up.empty.wifi": "Wi-Fi가 없습니다",
    "up.empty.order": "주문이 없습니다",
    "up.empty.coupon": "쿠폰이 없습니다",
    "up.empty.favor": "즐겨찾기가 없습니다",
    "up.empty.permission": "권한이 없습니다",
    "up.empty.history": "기록이 없습니다",
    "up.empty.news": "뉴스가 없습니다",
    "up.empty.message": "메시지가 없습니다",
    "up.empty.list": "목록이 비어 있습니다",
    "up.empty.data": "데이터가 없습니다",
    "up.empty.comment": "댓글이 없습니다",
    "up.link.copyed": "링크가 복사되었습니다. 브라우저에서 열어주세요",
    "up.loadmoe.loadmore": "더 불러오기",
    "up.loadmoe.nomore": "더 이상 데이터가 없습니다",
    "up.noNetwork.text": "네트워크 신호가 없습니다",
    "up.noNetwork.pleaseCheck": "네트워크를 확인하거나 이동하세요",
    "up.noNetwork.connect": "네트워크 연결됨",
    "up.noNetwork.disconnect": "네트워크 연결 끊김",
    "up.pagination.previous": "이전 페이지",
    "up.pagination.next": "다음 페이지",
    "up.pullRefresh.pull": "당겨서 새로고침",
    "up.pullRefresh.release": "놓아서 새로고침",
    "up.pullRefresh.refreshing": "새로고침 중",
    "up.readMore.expand": "펼쳐서 전체 보기",
    "up.readMore.fold": "접기",
    "up.search.placeholder": "키워드를 입력하세요",
    "up.signature.penSize": "선 굵기",
    "up.signature.penColor": "선 색상",
    "up.upload.sizeExceed": "용량 제한 초과",
    "up.upload.uploading": "업로드 중",
    "up.upload.previewImageFail": "이미지 미리보기 실패",
    "up.upload.previewVideoFail": "비디오 미리보기 실패",
    "up.goodsSku.stock": "재고",
    "up.goodsSku.price": "가격",
    "up.goodsSku.amount": "개",
    "up.goodsSku.choosed": "선택됨",
    "up.goodsSku.buyAmount": "구매 수량"
}
